import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MachineCategory} from '@models/adminstration/portal-setup/machine-category/machine-category';
import {
  MachineCategoryEditComponent
} from '@components/administration/portal-setup/portal-setup-machine-categories/modal/machine-category-edit/machine-category-edit.component';
import {TranslateService} from '@ngx-translate/core';
import {
  MachineCategoryColumnConfiguration
} from '@models/adminstration/portal-setup/machine-category/machine-category-column-configuration';
import {MachineCategoryService} from '@services/administration/portal-setup/machine-category/machine-category.service';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-machine-category-actions',
    templateUrl: './machine-category-actions.component.html',
    styleUrls: ['./machine-category-actions.component.scss'],
    standalone: false
})
export class MachineCategoryActionsComponent {

  @Input()
  searchTerm: string = '';

  @Input()
  machineCategory: MachineCategory = new MachineCategory();

  @Output()
  machineCategoryDeleteEvent = new EventEmitter<MachineCategory>();

  @Output()
  machineCategoryUpdatedEvent = new EventEmitter<MachineCategoryColumnConfiguration>();

  @Input()
  isSuperAdminRole: boolean = false;

  private readonly editCategoryPageTitle: string;

  constructor(private modalService: ModalService,
              private machineCategoryService: MachineCategoryService,
              private translate: TranslateService) {
    this.editCategoryPageTitle = this.translate.instant('Edit Category');
  }

  onDeleteMachineCategory(machineCategory: MachineCategory) {
    this.machineCategoryDeleteEvent.emit(machineCategory);
  }

  onEditMachineCategory(machineCategory: MachineCategory) {
    const modalRef = this.modalService.open(MachineCategoryEditComponent, {size: 'xl'});
    modalRef.componentInstance.machineCategory = machineCategory;
    modalRef.componentInstance.isInEditMode = true;
    modalRef.componentInstance.pageTitle = this.editCategoryPageTitle;
    modalRef.result.then((result) => {
      this.machineCategoryUpdatedEvent.emit(result.config);
    });
  }
}
